import { FbBetModel } from './FbBetModel';
import { FbMatch } from './FbMatch';

export class FbPackageTip{
  public fbMatch: FbMatch;
  public fbBets: FbBetModel[];

  constructor(fbMatch: FbMatch, fbBets: FbBetModel[]) {
    this.fbMatch = fbMatch;
    this.fbBets = fbBets;
  }
}



// WEBPACK FOOTER //
// ./src/model/FbPackageTip.ts